import React, { FC, useMemo } from 'react';
import merge from 'lodash/merge';
import {
  SelectOption as IMSelectOption,
  DataSelectProps,
} from '@im/ui-lib/SelectOption';

const defaultProps = {
  MenuProps: {
    PaperProps: {
      sx: (theme: any) => ({
        '& .MuiList-root': {
          padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
        },
        '& .MuiMenuItem-root': {
          fontSize: theme.typography.body2.fontSize,
          fontWeight: theme.typography.fontWeightRegular,
          lineHeight: theme.typography.body2.lineHeight,
          padding: `${theme.spacing(0.75)} ${theme.spacing(1)}`,
        },
        borderRadius: `${theme.shape.borderRadius}px`,
        boxShadow: theme.shadows.md,
      }),
    },
  },
  sx: {
    '& .MuiSvgIcon-root': {
      height: '18px !important',
      top: '6px',
      width: '18px !important',
    },
    '&.MuiOutlinedInput-root': {
      height: '33px',
    },
  },
};

const SelectOption: FC<DataSelectProps> = ({ children, ...props }) => {
  const selectProps = useMemo<DataSelectProps>(
    (): DataSelectProps => merge({}, defaultProps, props),
    [props]
  );
  return <IMSelectOption {...selectProps}>{children}</IMSelectOption>;
};

export default SelectOption;
